import Component from '@cell/cell-core/component/component';
import './language-selector.scss';

class LanguageSelector extends Component {
  constructor() {
    super();

    this.elements = {
      form: this.querySelector('form'),
      select: this.querySelector('select'),
      input: this.querySelector('input[name="language_code"]'),
    };
  }

  componentDidMount() {
    this.elements.select.on('change', this.handleLanguageChange.bind(this));
  }

  handleLanguageChange(event) {
    const selectedLanguage = event.target.value;

    this.elements.input.value = selectedLanguage;

    this.elements.form.submit();
  }
}

customElements.define('language-selector', LanguageSelector);
